export const title = 'Make My Trip';

export const meta = [
  {
    charset: 'UTF-8'
  },
  {
    name: 'viewport',
    content:
      'width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0'
  },
  {
    httpEquiv: 'X-UA-Compatible',
    content: 'IE=edge'
  }
];

export const script = [];

export const noscript = [];
